<template>
  <el-dialog
    append-to-body
    width="600px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">
        {{ info && info.id ? "编辑" : "新增" }}企业标签
      </div>
    </template>
    <el-form
      ref="elFormDomUploadDialog"
      label-width="120px"
      :model="form.data"
      :rules="form.rules"
    >
      <el-row type="flex" style="justify-content: center">
        <el-col :span="24">
          <el-form-item label="标签名称:" prop="name">
            <el-input
              v-model.trim="form.data.name"
              clearable
              maxlength="8"
              placeholder="请输入8个字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          v-loading="btnLoading"
          :disabled="btnLoading"
          type="primary"
          @click="conFirm"
          >保存</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      btnLoading: false,
      visible: false,
      form: {
        data: {
          name: "",
        },
        rules: {
          name: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    toggle(val) {
      this.visible = val;
    },
    getDetail(row) {
      this.info = row;
      this.form.data.name = row.name || "";
    },
    reset() {
      this.visible = false;
      this.$refs.elFormDomUploadDialog.resetFields();
    },
    conFirm() {
      this.$refs.elFormDomUploadDialog.validate((valid) => {
        if (valid) {
          let params = {
            name: this.form.data.name,
            id: this.info.id,
          };
          this.btnLoading = true;
          let url = this.info.id
            ? "/admin/company/editTag"
            : "/admin/company/createTag";
          this.$http
            .post(url, params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.reset();
                this.$emit("update");
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>